import { loadTool } from '@erikdakoda/tool-set/ai-tools/loadTool';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(loadTool);
